import { z } from "zod";

// Schema for getting native balance
export const GetNativeBalanceSchema = z.object({
    accountAddress: z.string().regex(/^0x[a-fA-F0-9]{40}$/, "Invalid Ethereum address format"),
});

export type GetNativeBalanceParams = z.infer<typeof GetNativeBalanceSchema>;

// Schema for transferring native tokens
export const TransferNativeSchema = z.object({
    to: z.string().regex(/^0x[a-fA-F0-9]{40}$/, "Invalid recipient address format"),
    amount: z.string().min(1, "Amount must be specified"),
});

export type TransferNativeParams = z.infer<typeof TransferNativeSchema>;

// Schema for wallet info
export const WalletInfoSchema = z.object({
    includeBalance: z.boolean().optional().default(true),
});

export type WalletInfoParams = z.infer<typeof WalletInfoSchema>;

// Common response types
export interface BalanceResponse {
    success: boolean;
    accountAddress?: string;
    balance?: string;
    balanceWei?: string;
    error?: string;
}

export interface TransferResponse {
    success: boolean;
    transactionHash?: string;
    from?: string;
    to?: string;
    amount?: string;
    error?: string;
}

export interface WalletInfoResponse {
    success: boolean;
    address?: string;
    balance?: string;
    balanceWei?: string;
    network?: string;
    error?: string;
}

// ERC721 specific schemas are exported from their respective action files

// COTI specific types
export interface CotiWalletConfig {
    privateKey?: string;
    rpcUrl?: string;
    networkId?: number;
    aesKey?: string;
}

export interface CotiProviderConfig {
    rpcUrl: string;
    networkId: number;
    timeout?: number;
}
